import script from "./PwResetRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./PwResetRequest.vue?vue&type=script&setup=true&lang=js"

import "./PwResetRequest.vue?vue&type=style&index=0&id=48a7d1c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a7d1c6"]])

export default __exports__